module.exports = __webpack_public_path__ + "img/loading.89c82b6c.gif";